import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ContextsService } from "src/app/api";
import { CombinedStore } from "src/app/core/combined.store";
import {
  civiliteObject,
  Civility,
} from "src/app/shared/models/model/concretes/shared/civility.model";
import { environment } from "src/environments/environment";
import { CreateContextRequestBuilder } from "../components/redirect/builders/create-context-request.builder";
import {
  ERROR_404_PATH,
  SUBSCRIPTION_PATH,
} from "../constants/route.constants";

@Injectable({
  providedIn: "root",
})
export class ProductGuard implements CanActivate {
  private store = inject(CombinedStore);
  constructor(
    private router: Router,
    private contextService: ContextsService,
  ) {}

  civilities: Civility[] = civiliteObject;

  canActivate(
    route: ActivatedRouteSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    const productCode = route.paramMap.get("productCode");

    if (!productCode) {
      console.error("Le productCode est null ou vide.");
      return false;
    }

    const requestBody = new CreateContextRequestBuilder()
      .withProduit(productCode)
      .withCodeVendeur(environment.brand)
      .build();

    const authorize = JSON.parse(
      environment.authorizeProspectBrands,
    ) as string[];

    if (authorize.some((m) => m == environment.brand))
      return this.contextService.apiContextsPost(requestBody).pipe(
        map((result: string) => {
          if (!environment.production) {
            console.log("Création du context réussie :", result);
          }
          const url = new URL(result);
          this.router.navigate([
            url.pathname.replace("/" + SUBSCRIPTION_PATH, ""),
          ]);
          return false;
        }),
        catchError((err) => {
          console.error("Erreur lors de la création du context :", err);
          return [false];
        }),
      );
    else {
      this.router.navigate([ERROR_404_PATH]);
      return false;
    }
  }
}
